var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterialui(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 204,
    viewBox: "0 0 256 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 110.848V0L96 55.424V92.3733L32 55.424V129.323L0 110.848Z",
    fill: "#00B0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55.424L192 0V110.848L128 147.797L96 129.323L160 92.3733V55.424L96 92.3733V55.424Z",
    fill: "#0081CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 129.322V166.272L160 203.221V166.272L96 129.322Z",
    fill: "#00B0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 203.221L256 147.797V73.8987L224 92.3733V129.323L160 166.272V203.221ZM224 55.424V18.4747L256 0V36.9493L224 55.424Z",
    fill: "#0081CB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialui);
export default __webpack_public_path__ + "static/media/materialui.d7f5c38f45cba4d9717da569bf6996ee.svg";
export { ForwardRef as ReactComponent };